import { FC } from "react";

export const PreLoading: FC = () => {
  return (
    <div className="w-[100vw] h-[100vh] flex justify-center items-center bg-blue-600">
      <img src={"/assets/images/logo.svg"} alt="logo" />
    </div>
  );
};
